import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { LoggerService } from '@pf/shared-services';
import { Operation } from 'fast-json-patch';
import { LaneLookupService, LanesService } from '@control-tower/platform-loads';
import { SchnFunctionsDataService } from './schn-functions-data.service';
import {
    ItemChargeStore,
    LaneCarrierStore,
    LaneCreate,
    LaneDataService,
    LaneRateStore,
    LaneRead,
    LaneStore,
} from '@pf/platform-loads/domain';

@Injectable()
export class RadiusLaneDataService extends LaneDataService {
    constructor(
        private schnFunctions: SchnFunctionsDataService,
        service: LanesService,
        lookupService: LaneLookupService,
        store: LaneStore,
        laneRateStore: LaneRateStore,
        itemChargeStore: ItemChargeStore,
        laneCarrierStore: LaneCarrierStore,
        logger: LoggerService
    ) {
        super(
            service,
            lookupService,
            store,
            laneRateStore,
            itemChargeStore,
            laneCarrierStore,
            logger
        );
    }

    override createObs$(body: LaneCreate): Observable<LaneRead> {
        return this.schnFunctions.laneCreate({
            originLocationId: body.originLocationId!,
            destinationLocationId: body.destinationLocationId!,
        }) as Observable<LaneRead>;
    }

    override deleteObs$(laneId: string): Observable<LaneRead> {
        return this.schnFunctions.laneDelete(laneId) as Observable<LaneRead>;
    }

    override undoDeleteObs$(laneId: string): Observable<LaneRead> {
        return super
            .undoDeleteObs$(laneId)
            .pipe(switchMap(lane => this.updateObs$(laneId, [], lane)));
    }

    override updateObs$(
        laneId: string,
        _: Operation[],
        modified: LaneCreate
    ): Observable<LaneRead> {
        return this.schnFunctions.laneUpdate({
            laneId,
            originLocationId: modified.originLocationId!,
            destinationLocationId: modified.destinationLocationId!,
        }) as Observable<LaneRead>;
    }
}
